import React, { useState, useEffect } from 'react'
import MainLayout from '../layout/MainLayout'
import axios from 'axios';
import CollectionTile from '../components/CollectionTile';


function Collections() {

    const [collectionGroups, setCollectionGroups] = useState([]);
    const getCollectionGroups = async () => {
        axios.get("/api/vi/collectionGroups")
            .then((result) => setCollectionGroups(result.data))
            .catch((err) => console.log(err));
    }


    const [collections, setCollections] = useState([]);
    const getCollections = async () => {
        axios.get("/api/v1/collections")
            .then((result) => setCollections(result.data))
            .catch((err) => console.log(err));

    };

    useEffect(() => {
        getCollections();
    }, []);




    return (
        <div>
            <MainLayout>
                <h1>Collections</h1>
                <br />
                <p>This is our current list of document collections. Look for additional collections every few weeks.</p>
                <br />
                {collections.map((collection, index) => (
                    <CollectionTile {...collection} key={index}></CollectionTile>
                ))}

            </MainLayout>
        </div>

    )
}

export default Collections
